// API Call URL
export const API_URL = process.env.REACT_APP_TG_API_URL

// Code debug flag
export const CODE_DEBUG = process.env.REACT_APP_TG_CODE_DEBUG

export const TINY_EDITOR_API_KEY = process.env.REACT_APP_TG_TINY_EDITOR_API_KEY
